import { useState, useEffect } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import { useSelector, useDispatch } from 'react-redux';
import strFunc from '@/lib/lyg/string';

function TextBookUsePageArea(props: any) {
  let myProps = {
    stu_seq: "",
    subject_name: "",
    select_date: "",
    refresh_data: () => { },
    ...props
  };
  let user = useSelector((state: any) => state.user);
  const [last_daily_report_arr, set_last_daily_report_arr] = useState<any>([]);
  const [book_use_info_arr, set_book_use_info_arr] = useState<any>([]);

  //마지막데일리 리포트를 가져오기.
  //교재정보,교재 사용기록 얻기.
  useEffect(() => {
    get_last_daily_report_arr_by_ajax({});
  }, [myProps.subject_name]);

  const get_last_daily_report_arr_by_ajax = (inData: any) => {
    let opt_obj = {
      ...inData
    };
    if (strFunc.is_empty(myProps.stu_seq)) {
      return false;
    }
    if (strFunc.is_empty(myProps.subject_name)) {
      return false;
    }
    let form_json_data: any = {
      s_stu_seq: myProps.stu_seq,
      s_subject: myProps.subject_name,
      order_id: "a_date DESC",
      "is_paging": "",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/daily_report_last/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          let tmp_info_arr = response.data["data"]["info_arr"];
          set_last_daily_report_arr(tmp_info_arr);
          let book_seq_arr: any = [];
          for (let i = 0; i < tmp_info_arr.length; i++) {
            let row_info = tmp_info_arr[i];
            if (row_info["a_textbook_par_id"] == "mtextbook") {
              if (!strFunc.is_empty(row_info["a_textbook_seq"])) {
                book_seq_arr.push(row_info["a_textbook_seq"]);
              }
            }
            if (row_info["a_subtextbook_par_id"] == "mtextbook") {
              if (!strFunc.is_empty(row_info["a_subtextbook_seq"])) {
                book_seq_arr.push(row_info["a_subtextbook_seq"]);
              }
            }
          }
          if (book_seq_arr.length > 0) {
            get_book_use_arr_by_ajax({ book_seq_arr: book_seq_arr });
          }
        } else {

        }
      });
  };
  const get_book_use_arr_by_ajax = (inData: any) => {
    let opt_obj = {
      book_seq_arr: [],
      ...inData
    };

    if (strFunc.is_empty(opt_obj.book_seq_arr)) {
      return false;
    }

    let form_json_data: any = {
      s_book_seq: opt_obj.book_seq_arr,
      s_stu_seq: myProps.stu_seq,
      s_addon_textbook: "1",
      "is_paging": "",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/textbook/use/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_book_use_info_arr(response.data["data"]["info_arr"]);
        } else {

        }
      });
  };

  const save_book_use_now_page_by_ajax = (inData: any) => {
    let opt_obj = {
      book_use_info: null,
      ...inData
    };
    let book_use_info = opt_obj.book_use_info;
    if (book_use_info == null) {
      alert("교재 사용 정보가 없습니다.");
      return false;
    }
    let form_json_data: any = {
      data_arr: [book_use_info],
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/textbook/use/write', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          get_last_daily_report_arr_by_ajax({});
          myProps.refresh_data();
        } else {
          alert("저장에 실패했습니다.");
        }
      });
  };

  let wrap_style: any = {
    position: "relative",
    width: "95%",
    margin: "0 auto",
    marginTop: 5,
    display: "flex",
    gap: "10px",
  };

  return (
    <div style={wrap_style}>
      {(book_use_info_arr.length > 0) &&
        book_use_info_arr.map((book_use_info: any, idx: number) => {
          let now_page = 0;
          let total_page = 1;
          let text_book_title = "";
          let book_pdf_url = "";
          if (book_use_info != null) {
            now_page = book_use_info["a_now_page"];
            if (book_use_info["textbook_info"]) {
              total_page = book_use_info["textbook_info"]["a_book_total_page"];
              text_book_title = book_use_info["textbook_info"]["a_title"];
              book_pdf_url = book_use_info["textbook_info"]["a_book_pdf_url"];
            }
          }
          if (strFunc.is_empty(now_page)) {
            now_page = 1;
          }

          if (strFunc.is_empty(book_pdf_url)) {
            return "";
          }

          return (
            <span key={idx}>
              <img src={process.env.REACT_APP_API_URL + "/img/mobile/ico/book_ico.png"} style={{ height: "30px" }} />
              <span className='ml-1'>
                <input type='text' name="book_now_page" value={now_page}
                  onClick={(e: any) => { e.target.select(); }}
                  onChange={(e: any) => {
                    let val = strFunc.uncomma_int(e.target.value);
                    let change_book_use_info = { ...book_use_info };
                    change_book_use_info["a_now_page"] = val;
                    let change_book_use_info_arr=[...book_use_info_arr];
                    change_book_use_info_arr[idx]=change_book_use_info;
                    set_book_use_info_arr(change_book_use_info_arr);
                  }}
                  style={{ width: 40, textAlign: "center" }}
                />
              </span>
              <span> / </span>
              <span>{total_page}</span>
              <span className='ml-1'>
                ({text_book_title})
              </span>
              <button className='btn btn-dark ml-1'
                onClick={() => {
                  save_book_use_now_page_by_ajax({book_use_info: book_use_info});
                }}>저장</button>
            </span>
          );
        })
      }
    </div>
  );
};
export default TextBookUsePageArea;